// Dependencies

import React, { Component } from 'react';

// Components

import Header from '../Header/Header';

// Images

import question from '../images/help.svg';
import travel from '../images/travel.svg';
import setUp from '../images/set-up.svg';
import party from '../images/party.svg';

// Style

import './HowItWorks.css';

class HowItWorks extends React.Component {

  render() {
    return (
        <div className="how-it-works">
          <div className="how-it-works__header-wrapper">
            <Header icon={question} heading="How it Works"/>
          </div>
          <div className="how-it-works__steps-wrapper">
            <div className="how-it-works__step">
            <div className="how-it-works__step-image-wrapper">
            <img alt="Travel" className="how-it-works__step-image" src={travel} />
            </div>
              <h3>We Come to You</h3>
              <p>Hibachi & You will pack up and travel to you anywhere in <span>South Florida</span>.</p>

            </div>
            <div className="how-it-works__step">
            <div className="how-it-works__step-image-wrapper">
              <img alt="Travel" className="how-it-works__step-image" src={setUp} />
            </div>
                <h3>We Adapt to the Location</h3>
                <p>Hibachi & You adapts to <span>any location and event</span> to host your party.</p>
            </div>
            <div className="how-it-works__step">
              <div className="how-it-works__step-image-wrapper">
                <img alt="Travel" className="how-it-works__step-image" src={party} />
            </div>
                <h3>Perfect Party</h3>
                <p>Enjoy delicious Hibachi cuisine and an expert catering experience.</p>

            </div>
          </div>
        </div>
    );
  } 
  }
 

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/HowItWorks/HowItWorks.js